
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $8LewD = parcelRequire("8LewD");
var $8f13b60c0ee5b277$exports = {};
$8f13b60c0ee5b277$exports = JSON.parse("{\"name\":\"micro-frontends\",\"version\":\"1.0.0\",\"repository\":\"git@github.com:Javiani/micro-frontends.git\",\"author\":\"Javiani <eduardo.ottaviani@gmail.com>\",\"license\":\"MIT\",\"host\":\"https://mfe-jails.netlify.app\",\"scripts\":{\"dev\":\"NODE_ENV=dev parcel src/mfes/**/page.pug --no-cache\",\"build\":\"rm -rf ./dist && parcel build src/shared/main.ts && parcel build src/mfes/**/*.{css,ts,pug} --no-content-hash --no-cache\",\"create:mfe\":\"node tasks/create\"},\"devDependencies\":{\"@parcel/transformer-pug\":\"^2.13.0\",\"parcel\":\"^2.13.0\"},\"dependencies\":{\"@rive-app/canvas\":\"^2.13.2\",\"jails-js\":\"^6.3.3\",\"jails.std\":\"^0.2.5\",\"swiper\":\"^11.2.6\"}}");


const $babaa9941c244e10$var$origin = (0, (/*@__PURE__*/$parcel$interopDefault($8f13b60c0ee5b277$exports))).host;
const $babaa9941c244e10$var$mfes = [];
window.MFE = {
    register (name, module, dependencies) {
        (0, $8LewD.register)(name, module, dependencies);
    },
    add (name, target) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = `${$babaa9941c244e10$var$origin}/${name}/index.css`;
        document.head.appendChild(link);
        fetch(`${$babaa9941c244e10$var$origin}/${name}/index.html`).then((res)=>res.text()).then((h)=>document.querySelector(target).innerHTML = h);
        const app = document.createElement('script');
        app.defer = true;
        $babaa9941c244e10$var$mfes.push(new Promise((resolve)=>{
            app.src = `${$babaa9941c244e10$var$origin}/${name}/index.js`;
            app.onload = resolve;
            document.head.appendChild(app);
        }));
        return this;
    },
    start () {
        Promise.allSettled($babaa9941c244e10$var$mfes).then((_)=>(0, $8LewD.start)());
    }
};


//# sourceMappingURL=page.31337acd.js.map
